import React, { useMemo } from 'react';

import { Tooltip, ErrorOutlineIcon } from '@gogame/components';

const Fraud = ({ redAlert }) => {
  const tooltip = useMemo(() => {
    return redAlert
      ? 'Over 4% of total rejected installs / total installs detected'
      : 'Rejected regs\\installs detected';
  }, [redAlert]);

  return (
    <Tooltip title={tooltip}>
      <ErrorOutlineIcon
        color={redAlert ? 'error' : 'action'}
        sx={{ fontSize: 18, lineHeight: 18 }}
        tooltip={tooltip}
      />
    </Tooltip>
  );
};

export default Fraud;
